export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/noop.js
// module id = ./node_modules/d3-contour/src/noop.js
// module chunks = 54